import { render, staticRenderFns } from "./AdminPayerCreate.vue?vue&type=template&id=da59b632"
import script from "./AdminPayerCreate.vue?vue&type=script&lang=js"
export * from "./AdminPayerCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports